// RoboMesh pre-translated content for Chinese
export const ROBOMESH_TRANSLATIONS = {
  zh: {
    welcomeSimple: "欢迎使用 **RoboMesh** — 您的现实世界任务助手。\n\n我会为物理任务、物流、安全和日常问题提供实用、易于理解的建议。没有术语，只有有用的指导。\n\n**您想完成什么？**",
    welcomeExpert: "欢迎使用 **RoboMesh 专家模式** — 技术机器人推理引擎。\n\n我提供详细的技术分析：机器人规格、控制算法、安全系统和量化风险评估。\n\n**您要解决什么机器人挑战？**",
    startersSimple: [
      "我想整理车库 - 我该怎么做？",
      "如何安全地移动重箱子而不伤害自己？",
      "为三居室房屋制定简单的清洁计划",
      "我需要高效地设置家庭办公室 - 帮我规划"
    ],
    startersExpert: [
      "为20k SKU的仓库设计带AMR协调的人形机器人运行系统",
      "指定医院标本运输系统的机器人要求",
      "计算6轴臂精密装配的故障模式",
      "分析受限空间中的多代理碰撞避免"
    ],
    reasoning: "推理中...",
    thinking: "思考中...",
    suggestedNextSteps: "建议的下一步"
  }
};

export const getRoboMeshWelcome = (mode, language) => {
  if (language === 'zh') {
    return mode === 'expert' ? ROBOMESH_TRANSLATIONS.zh.welcomeExpert : ROBOMESH_TRANSLATIONS.zh.welcomeSimple;
  }
  return mode === 'expert'
    ? "Welcome to **RoboMesh Expert Mode** — technical robotics reasoning engine.\n\nI provide detailed technical analysis: robot specifications, control algorithms, safety systems, and quantified risk assessments.\n\n**What robotics challenge are you solving?**"
    : "Welcome to **RoboMesh** — your helper for real-world tasks.\n\nI'll give you practical, easy-to-understand advice for physical tasks, logistics, safety, and everyday problems. No jargon, just helpful guidance.\n\n**What do you want to accomplish?**";
};

export const getRoboMeshStarters = (mode, language) => {
  if (language === 'zh') {
    return mode === 'expert' ? ROBOMESH_TRANSLATIONS.zh.startersExpert : ROBOMESH_TRANSLATIONS.zh.startersSimple;
  }
  return mode === 'expert'
    ? [
        "Design a humanoid-run warehouse for 20k SKUs with AMR coordination",
        "Specify robot requirements for hospital specimen transport system",
        "Calculate failure modes for precision assembly with 6-axis arm",
        "Analyze multi-agent collision avoidance in confined space"
      ]
    : [
        "I want to organize my garage with help - what should I do?",
        "How can I safely move heavy boxes without hurting myself?",
        "Plan a simple cleaning routine for a 3-bedroom house",
        "I need to set up a home office efficiently - help me plan it"
      ];
};

export const getRoboMeshReasoningLabel = (language) => {
  return language === 'zh' ? "推理中..." : "Reasoning...";
};

export const getRoboMeshThinkingLabel = (language) => {
  return language === 'zh' ? "思考中..." : "Thinking...";
};

export const getRoboMeshSuggestedLabel = (language) => {
  return language === 'zh' ? "建议的下一步" : "Suggested next steps";
};
